import { useEffect, useState } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { CustomButtonPlusIcon } from "../Design/CustomButtonPlusIcon";
import { dateFormat, handleDates, quitarTildes } from "../../helpers/Helpers";

import { AccessTime, Gavel, Visibility, Warning } from "@mui/icons-material";

// Componentes propios
import { CustomIconsPlusText } from "../Design/CustomIconsPlusText";

// Paginación
import dayjs from "dayjs";

export const RenderCell = ({
  value,
  defaultValue = "Sin asignar",
  link = false,
  dateFlag = false,
  icon: Icon,
  sx,
  id,
  view,
  color,
  iconPosition,
}) => {
  const [displayValue, setDisplayValue] = useState("");

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.down("md")); // true si md o menos

  const isValidValue =
    value != null &&
    value !== "" &&
    value !== "undefined" &&
    !String(value).includes("undefined");

  useEffect(() => {
    const isDate = (value) => {
      if (!value) return false;

      // Solo strings con el formato correcto
      if (typeof value === "string") {
        return dayjs(value, "YYYY-MM-DD HH:mm:ss", true).isValid();
      }

      return false;
    };

    if (isValidValue) {
      if (dateFlag && isDate(value)) {
        setDisplayValue(dateFormat(value));
      } else {
        setDisplayValue(value);
      }
    } else {
      setDisplayValue(defaultValue);
    }
  }, []);

  return (
    <div className="spanClassForTables centerContent">
      {link && isValidValue ? (
        <CustomButtonPlusIcon
          sx={sx}
          to={`/${view}/ver?id=${id}`}
          icon={Icon}
          text={isMd ? "" : displayValue}
          size="small"
          position={iconPosition || "start"}
          color={color}
          variant="outlined"
        />
      ) : (
        displayValue
      )}
    </div>
  );
};

export const RenderVencimiento = ({
  last_task: current_task,
  cases_flow_relation: flow,
  flagFromPanel = false,
  flagTrial = false,
}) => {
  const fechaFormateada = dateFormat(current_task?.date_end);
  const iconSize = { width: "15px", height: "15px" };

  // Calcular diferencia en días con dayjs
  const diffDays = current_task?.date_end
    ? dayjs(current_task.date_end).diff(dayjs(), "day")
    : null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: flagFromPanel ? "row" : "column",
        gap: "3px",
        padding: "2px",
      }}>
      {/* Si el estado es juicio */}
      {/* Si la tarea está activa y con fecha */}
      {diffDays !== null && (
        <>
          {diffDays > 5 && (
            <CustomIconsPlusText
              chipStyles={{ width: "auto" }}
              icon={AccessTime}
              iconStyles={iconSize}
              severity="info"
              text={`${diffDays} días para finalizar la tarea`}
              variant={"outlined"}
            />
          )}

          {diffDays > 0 && diffDays <= 5 && (
            <CustomIconsPlusText
              chipStyles={{ width: "auto" }}
              icon={Warning}
              iconStyles={iconSize}
              blink="blinking"
              severity="warning"
              text={`${diffDays} días para finalizar la tarea`}
              variant={"outlined"}
            />
          )}

          {diffDays <= 0 && (
            <CustomIconsPlusText
              chipStyles={{ width: "auto" }}
              icon={Warning}
              iconStyles={iconSize}
              blink="blinking"
              severity="error"
              text={`Tarea vencida hace ${Math.abs(diffDays)} días`}
              variant={"outlined"}
            />
          )}
        </>
      )}

      {/* Fecha de vencimiento */}
      <CustomIconsPlusText
        chipStyles={{ width: "auto" }}
        icon={AccessTime}
        iconStyles={iconSize}
        severity="none"
        text={`Fecha: ${fechaFormateada ? fechaFormateada : "Sin programar"}`}
        variant={"outlined"}
      />
    </div>
  );
};

export const RenderTrialDate = ({
  dates,
  cases_flow_relation: flow,
  flagFromPanel = false,
  flagTrial = false,
}) => {
  const date = dates?.date_end;
  const iconSize = { width: "15px", height: "15px" };

  const now = dayjs();

  const diffDays = date ? dayjs(date).diff(now, "day") : null;
  const diffHours =
    date && diffDays !== null ? dayjs(date).diff(now, "hour") % 24 : null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: flagFromPanel ? "row" : "column",
        gap: "3px",
        padding: "2px",
      }}>
      {diffDays !== null && (
        <>
          {diffDays > 15 && (
            <CustomIconsPlusText
              chipStyles={{ width: "auto" }}
              icon={Gavel}
              iconStyles={iconSize}
              text={
                dates?.source === "task_date"
                  ? "JUICIO POR VENCIMIENTO DE TAREA"
                  : "JUICIO FECHA REAL PROGRAMADA"
              }
              blink="blinking"
              severity="warning"
              variant="contained"
            />
          )}

          {diffDays > 0 && diffDays <= 15 && (
            <CustomIconsPlusText
              chipStyles={{ width: "auto" }}
              icon={Gavel}
              iconStyles={iconSize}
              text={
                dates?.source === "task_date"
                  ? "JUICIO POR VENCIMIENTO DE TAREA"
                  : "JUICIO FECHA REAL PROGRAMADA"
              }
              blink="blinking"
              severity="error"
              variant="contained"
            />
          )}

          {diffDays > 5 && (
            <CustomIconsPlusText
              chipStyles={{ width: "auto" }}
              icon={AccessTime}
              iconStyles={iconSize}
              severity="info"
              text={`Faltan ${diffDays} días ${diffHours} horas`}
              variant="outlined"
            />
          )}

          {diffDays > 0 && diffDays <= 5 && (
            <CustomIconsPlusText
              chipStyles={{ width: "auto" }}
              icon={Warning}
              iconStyles={iconSize}
              blink="blinking"
              severity="warning"
              text={`Faltan ${diffDays} días ${diffHours} horas`}
              variant="outlined"
            />
          )}

          {diffDays <= 0 && (
            <CustomIconsPlusText
              chipStyles={{ width: "auto" }}
              icon={Warning}
              iconStyles={iconSize}
              blink="blinking"
              severity="error"
              text={`Tarea vencida hace ${Math.abs(diffDays)} días`}
              variant="outlined"
            />
          )}
        </>
      )}

      <CustomIconsPlusText
        chipStyles={{ width: "auto" }}
        icon={AccessTime}
        iconStyles={iconSize}
        severity="none"
        text={`Fecha: ${date ?? "No programada"}`}
        variant="outlined"
      />
    </div>
  );
};
